
<app-topnav></app-topnav>

<div class="page-heading-banner dashboard-color">
  <div class="container">
    <div class="dahsboard-banner-content">
      <h1>{{'videosText'|translate:translation}}</h1>
      <span>{{'browseVideoText'|translate:translation}}</span>
    </div>
  </div>
</div>


<div class="container">
  <div class="content">
    <div class="h-30"></div>
    <div class="video-playlist">
      @for (video of videoList; track video) {
        <div class="video-card col-sm-6 col-md-4 col-lg-3">
          <div class="video-card-content">
            <img [src]="video.thumbnailURL" class="video-card-item-image">
            <h4 class="item-name">{{video.title}}</h4>
            <div class="item-actions">
              <button class="video-card-button" (click)="openVideoPlayer(video.vimeoVideoId,video.title,video.id)"><i class="fa fa-play-circle"></i> {{'watchVideoText'|translate:translation}}</button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>


<div class="program-packs">
  <div class="container">
    <div class="col-sm-6 col-md-6 col-md-offset-3">
      <h2>Program Pack</h2>
      <ul class="list-group">
        @for (pp of programPacks; track pp) {
          <li class="list-group-item program-pack-item">
            <span>{{pp.programPackTitle}}</span>
            <a [href]="pp.programPackURL" target="_blank" class="btn btn-sm btn-primary text-right pull-right video-store-login-button"><i class="fa fa-download"></i> {{'downloadText'|translate:translation}}</a>
          </li>
        }
      </ul>
    </div>
  </div>
</div>



<app-footer [bbapp]="true"></app-footer>
